/* DJ demo: scroll reveals, drag-to-scroll lookbook, pattern finder filter. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveals: tagged elements plus the main homepage sections.
  const revealTargets = document.querySelectorAll(
    '.dj-reveal, .dj-spotlight__media, .dj-spotlight__content, .dj-values__item, .dj-lookbook__item'
  );
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  } else {
    document.documentElement.classList.add('dj-motion');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    revealTargets.forEach((el, i) => {
      el.style.setProperty('--reveal-delay', `${(i % 4) * 90}ms`);
      io.observe(el);
    });
  }

  // Drag-to-scroll for the lookbook (touch already scrolls natively).
  document.querySelectorAll('[data-dj-drag]').forEach((track) => {
    let startX = 0;
    let startScroll = 0;
    let moved = false;
    let down = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', () => {
      down = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener(
      'click',
      (e) => {
        if (moved) {
          e.preventDefault();
          moved = false;
        }
      },
      true
    );
  });

  // Pattern finder: filter cards by keyword.
  document.querySelectorAll('[data-dj-finder]').forEach((finder) => {
    const chips = finder.querySelectorAll('.dj-chip');
    const cards = finder.querySelectorAll('.dj-finder__card');
    const empty = finder.querySelector('.dj-finder__empty');
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((c) => c.classList.toggle('is-active', c === chip));
        const key = chip.dataset.filter;
        let shown = 0;
        cards.forEach((card) => {
          const match = !key || card.dataset.keys.includes(key);
          card.classList.toggle('is-hidden', !match);
          if (match) {
            shown += 1;
            card.classList.add('is-in');
          }
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  });
})();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-dj-copy]');
  if (!btn) return;
  e.preventDefault();
  navigator.clipboard?.writeText(btn.dataset.djCopy);
  btn.classList.add('is-copied');
  setTimeout(() => btn.classList.remove('is-copied'), 1800);
});

/* Quiet luxury motion: soft rises, drawn gold lines, gentle photo reveals, number count-up. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const groups = [
    // homepage
    ['.dj-finder__head > *, .dj-finder [class*="card"]', 'dj-a-rise'],
    ['.dj-yt__eyebrow, .dj-yt__heading, .dj-yt__body', 'dj-a-rise'],
    ['[id*="dj_business_tools"] h3, [id*="dj_business_tools"] p, [id*="dj_business_tools"] .product-card, [id*="dj_business_tools"] product-card', 'dj-a-rise'],
    ['.dj-values__heading', 'dj-a-rise'],
    ['.dj-values__rule, .dj-yt__rule', 'dj-a-draw'],
    // resources
    ['.dj-res__head > *, .dj-res__nav, .dj-res__printables > .dj-res__eyebrow, .dj-res__sub', 'dj-a-rise'],
    ['.dj-res__card', 'dj-a-rise'],
    ['.dj-res__num, .dj-res__h, .dj-res__sec > p, .dj-res__note, .dj-res__video, .dj-calc', 'dj-a-rise'],
  ];
  const seen = new Set();
  const els = [];
  groups.forEach(([sel, cls]) => {
    let list = [];
    try { list = [...document.querySelectorAll(sel)]; } catch (e) { return; }
    list.forEach((el) => {
      if (seen.has(el) || el.closest('.dj-reveal') && cls === 'dj-a-rise' && el !== el.closest('.dj-reveal')) return;
      seen.add(el); el.classList.add(cls); els.push(el);
    });
  });
  if (!els.length) return;
  document.documentElement.classList.add('dj-anim');
  const io = new IntersectionObserver((entries) => {
    // stagger siblings that enter together
    let n = 0;
    entries.filter((e) => e.isIntersecting).forEach((e) => {
      const d = `${Math.min(n++, 5) * 110}ms`;
      const targets = proxyFor.get(e.target) || [e.target];
      if (!proxyFor.has(e.target) || e.target.classList.contains('dj-a-rise') || e.target.classList.contains('dj-a-draw')) targets.push(e.target);
      targets.forEach((t) => { t.style.setProperty('--dj-d', d); t.classList.add('dj-in'); });
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
  // Clipped (veiled) elements can't be seen by the observer, so watch their parent instead.
  const proxyFor = new Map();
  els.forEach((el) => {
    if (el.classList.contains('dj-a-veil') && el.parentElement) {
      const host = el.parentElement;
      if (!proxyFor.has(host)) proxyFor.set(host, []);
      proxyFor.get(host).push(el);
      io.observe(host);
    } else {
      io.observe(el);
    }
  });

  // count-up for the "Loved by makers" numbers
  const nums = document.querySelectorAll('.dj-values__item h3');
  const cio = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      const raw = e.target.textContent.trim();
      const m = raw.match(/^([\d,]+)(.*)$/);
      if (!m) return;
      const end = parseInt(m[1].replace(/,/g, ''), 10);
      const t0 = performance.now(), dur = 1800;
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / dur);
        const v = Math.round(end * (1 - Math.pow(1 - p, 3)));
        e.target.textContent = v.toLocaleString('en-US') + m[2];
        if (p < 1) requestAnimationFrame(tick); else e.target.textContent = raw;
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.6 });
  nums.forEach((n) => cio.observe(n));
})();

/* About FAQ: split questions into two fixed columns so opening one never reshuffles the rest. */
(() => {
  const box = document.querySelector('.dj-about__faq .dj-faqs');
  if (!box || box.dataset.split) return;
  const items = [...box.querySelectorAll(':scope > details.dj-faq')];
  if (items.length < 4) return;
  box.dataset.split = '1';
  const half = Math.ceil(items.length / 2);
  [items.slice(0, half), items.slice(half)].forEach((group) => {
    const col = document.createElement('div');
    col.className = 'dj-faqs__col';
    group.forEach((d) => col.append(d));
    box.append(col);
  });
  box.classList.add('dj-faqs--split');
})();

/* Newsletter: gentle entrance when it scrolls into view. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const box = document.querySelector("[id*='footer'] .footer-content > .group-block:has(.email-signup-block)");
  if (!box) return;
  box.classList.add('dj-nl');
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    box.classList.add('dj-nl--in'); io.disconnect();
  }), { threshold: 0.25 });
  io.observe(box);
})();

/* Safety net: reveal any animated element already on screen (covers browsers where the observer misses). */
(() => {
  const sel = '.dj-a-rise:not(.dj-in), .dj-a-veil:not(.dj-in), .dj-a-draw:not(.dj-in), .dj-nl:not(.dj-nl--in)';
  let ticking = false;
  const check = () => {
    ticking = false;
    const vh = window.innerHeight;
    document.querySelectorAll(sel).forEach((el) => {
      const r = (el.classList.contains('dj-a-veil') && el.parentElement ? el.parentElement : el).getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > 0) el.classList.add(el.classList.contains('dj-nl') ? 'dj-nl--in' : 'dj-in');
    });
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('load', () => setTimeout(check, 400));
  setInterval(check, 1500);
})();

/* Studio Essentials: Lookbook-style overlay arrows on the scroll-through. */
(() => {
  const sec = document.querySelector("[id*='dj_business_tools']");
  if (!sec) return;
  const findScroller = () => [...sec.querySelectorAll('*')].find((e) => {
    const o = getComputedStyle(e).overflowX;
    return (o === 'auto' || o === 'scroll') && e.scrollWidth > e.clientWidth + 10;
  });
  const init = () => {
    const sc = findScroller();
    if (!sc || sec.querySelector('.dj-se-arrow')) return !!sc;
    const host = sc.parentElement;
    host.classList.add('dj-se-host');
    const mk = (dir) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'dj-se-arrow'; b.dataset.dir = dir;
      b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
      b.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="${dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>`;
      b.addEventListener('click', () => {
        const card = sc.querySelector('product-card, .product-card, li, [class*=slide]');
        const step = card ? card.getBoundingClientRect().width + 16 : sc.clientWidth * 0.8;
        sc.scrollBy({ left: step * dir, behavior: 'smooth' });
      });
      host.append(b);
      return b;
    };
    const prev = mk(-1), next = mk(1);
    const place = () => {
      const img = sc.querySelector('img');
      if (img) {
        const top = img.getBoundingClientRect().top - host.getBoundingClientRect().top + img.getBoundingClientRect().height / 2;
        prev.style.top = next.style.top = `${top}px`;
      }
      const max = sc.scrollWidth - sc.clientWidth;
      prev.classList.toggle('is-hidden', sc.scrollLeft < 30);
      next.classList.toggle('is-hidden', sc.scrollLeft > max - 4);
    };
    sc.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    setTimeout(place, 600);
    place();
    return true;
  };
  if (!init()) {
    let tries = 0;
    const t = setInterval(() => { if (init() || ++tries > 20) clearInterval(t); }, 300);
  }
})();

/* Help page: each numbered section becomes an elegant drop-down; "Jump to" links open the right one. */
(() => {
  const root = document.querySelector('.dj-res:has(.dj-help__contact), .dj-res:has([data-dj-dict-search])');
  if (!root) return;
  root.classList.add('dj-help--acc');
  const isDict = !!root.querySelector('[data-dj-dict-search]');
  if (isDict) root.classList.add('dj-dict--acc');
  root.querySelectorAll('.dj-res__sec').forEach((sec) => {
    const h = sec.querySelector('.dj-res__h');
    if (!h || sec.querySelector('details')) return;
    const d = document.createElement('details');
    d.className = 'dj-help__acc';
    const sum = document.createElement('summary');
    const num = sec.querySelector('.dj-res__num');
    if (num) sum.append(num);
    sum.append(h);
    const body = document.createElement('div');
    body.className = 'dj-help__body';
    [...sec.childNodes].forEach((n) => { if (!(n.classList && n.classList.contains('dj-res__top'))) body.append(n); });
    sec.querySelectorAll('.dj-res__top').forEach((t) => t.remove());
    d.append(sum, body);
    sec.append(d);
  });
  const openHash = () => {
    const id = location.hash.slice(1);
    const sec = id && document.getElementById(id);
    const d = sec && sec.querySelector('details.dj-help__acc');
    if (d) { d.open = true; sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  };
  root.querySelectorAll('.dj-res__nav a[href^="#"]').forEach((a) => a.addEventListener('click', () => setTimeout(openHash, 0)));
  window.addEventListener('hashchange', openHash);
  openHash();
  // Dictionary search: open every section that still has matches; close them again when cleared.
  const search = root.querySelector('[data-dj-dict-search]');
  if (search) search.addEventListener('input', () => {
    const q = search.value.trim();
    root.querySelectorAll('.dj-res__sec').forEach((sec) => {
      const d = sec.querySelector('details.dj-help__acc');
      if (d) d.open = !!q && !sec.hidden;
    });
  });
})();

// Newsletter sign-up: post into a hidden frame (Shopify's own submit + spam check still run),
// then show "Thanks for subscribing!" in place instead of reloading and jumping to the form.
// If Shopify asks for a visible captcha, open that page so the visitor can finish.
(() => {
  const forms = document.querySelectorAll('form.email-signup__form');
  if (!forms.length) return;
  const frame = document.createElement('iframe');
  frame.name = 'dj-nl-frame'; frame.hidden = true; frame.setAttribute('aria-hidden', 'true'); frame.tabIndex = -1;
  document.body.append(frame);
  let active = null;
  forms.forEach((form) => {
    form.target = 'dj-nl-frame';
    form.addEventListener('submit', () => { active = form; });
  });
  frame.addEventListener('load', () => {
    const form = active; if (!form) return;
    let doc, url = '';
    try { doc = frame.contentDocument; url = frame.contentWindow.location.href; } catch (_) { doc = null; }
    if (!doc || url === 'about:blank') return;
    if (/\/challenge/.test(url)) { window.location.href = url; return; }
    const msg = doc.querySelector('[id^="Email-signup__message-success"]') || doc.querySelector('[id^="Email-signup__message-error"]');
    if (!msg) { window.location.href = url; return; }
    form.querySelectorAll('.email-signup__message').forEach((m) => m.remove());
    active = null;
    if (msg.id.includes('success')) {
      const input = form.querySelector('input[type="email"]'); if (input) { input.value = ''; input.blur(); }
      thanks();
      return;
    }
    const node = document.importNode(msg, true);
    node.removeAttribute('id'); node.setAttribute('role', 'status');
    form.append(node);
  });

  // The thank-you moment: page softly blurs, a cream card floats up, a checkmark draws itself.
  const css = document.createElement('style');
  css.textContent = `
    .dj-thanks{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;
      background:rgba(45,43,41,.28);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);opacity:0;transition:opacity .6s ease}
    .dj-thanks.is-on{opacity:1}
    .dj-thanks__card{position:relative;width:min(440px,100%);background:#faf8f4;color:#2d2b29;text-align:center;
      padding:56px 40px 48px;border:1px solid #e6ded3;box-shadow:0 30px 80px rgba(45,43,41,.22);
      transform:translateY(18px) scale(.98);transition:transform .9s cubic-bezier(.2,.8,.2,1)}
    .dj-thanks.is-on .dj-thanks__card{transform:none}
    .dj-thanks__mark{width:54px;height:54px;margin:0 auto 22px;display:block}
    .dj-thanks__mark circle{fill:none;stroke:#b8a690;stroke-width:1;stroke-dasharray:160;stroke-dashoffset:160;transition:stroke-dashoffset 1.1s ease .25s}
    .dj-thanks__mark path{fill:none;stroke:#5c4a3e;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:30;stroke-dashoffset:30;transition:stroke-dashoffset .7s ease 1.05s}
    .dj-thanks.is-on .dj-thanks__mark circle,.dj-thanks.is-on .dj-thanks__mark path{stroke-dashoffset:0}
    .dj-thanks__title{margin:0;font-family:var(--font-heading--family,'Cormorant',serif);font-style:italic;font-weight:400;
      font-size:clamp(30px,6vw,38px);line-height:1.15;letter-spacing:.01em;color:#2d2b29;opacity:0;transform:translateY(8px);
      transition:opacity .8s ease .55s,transform .8s ease .55s}
    .dj-thanks__rule{display:block;width:0;height:1px;margin:22px auto 0;background:#b8a690;transition:width .9s ease 1s}
    .dj-thanks.is-on .dj-thanks__title{opacity:1;transform:none}
    .dj-thanks.is-on .dj-thanks__rule{width:64px}
    .dj-thanks__close{position:absolute;top:12px;right:14px;width:36px;height:36px;border:0;background:none;color:#5c4a3e;font-size:22px;line-height:1;cursor:pointer;opacity:.6}
    .dj-thanks__close:hover{opacity:1}
    @media (prefers-reduced-motion:reduce){.dj-thanks,.dj-thanks *{transition:none!important}}`;
  document.head.append(css);
  function thanks() {
    const wrap = document.createElement('div');
    wrap.className = 'dj-thanks'; wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-live', 'polite'); wrap.setAttribute('aria-label', 'Thank you for subscribing');
    wrap.innerHTML = '<div class="dj-thanks__card"><button type="button" class="dj-thanks__close" aria-label="Close">&times;</button>'
      + '<svg class="dj-thanks__mark" viewBox="0 0 54 54" aria-hidden="true"><circle cx="27" cy="27" r="25"/><path d="M18 27.5l6 6 12-13"/></svg>'
      + '<p class="dj-thanks__title">Thank you for subscribing</p><span class="dj-thanks__rule"></span></div>';
    document.body.append(wrap);
    requestAnimationFrame(() => requestAnimationFrame(() => wrap.classList.add('is-on')));
    const close = () => { wrap.classList.remove('is-on'); setTimeout(() => wrap.remove(), 650); document.removeEventListener('keydown', esc); };
    const esc = (e) => { if (e.key === 'Escape') close(); };
    wrap.addEventListener('click', (e) => { if (e.target === wrap || e.target.closest('.dj-thanks__close')) close(); });
    document.addEventListener('keydown', esc);
    setTimeout(close, 6000);
  }
  window.djNewsletterThanks = thanks;   // preview hook for checking the design
})();
